<template>
  <div class="hello">
    <div class="body1Box">
      <div class="body1Box1">
        <img src="../../../static/image/sel.png" class="body1Box1_1" />
        <input v-model="ssinput" placeholder="请输入内容" class="body1Box1_2"></input>
        <div class="body1Box1_3" @click="selButton"></div>
      </div>
      <div class="body1Box2" >
        <div v-for="(item,i) in typeList" @click="selType(i,item.name)" v-bind:value="i" >{{item.name}}</div>
      </div>
    </div>
    <div class="body2Box">
      <div class="body2Box1">
        <div class="body2Box1_1Box" @mouseleave="UpRoll()">
          <div class="body2Box1_1" v-for="(item,i) in typeList1" @mouseenter="StopRoll(item.id)">
            <img src="../../../static/image/meishi.png" class="typePhoto"/>
            <div class="typeBox">{{item.name}}</div>
            <img class="you" src="../../../static/image/you.png" />
          </div>
        </div>
      </div>
      <div class="body2Box2">
        <el-carousel class="seiperBox" height="240px" :interval="5000">
          <el-carousel-item v-for="item in 4" :key="item" style="height: 240px;" >
            <img src="http://p1.meituan.net/codeman/826a5ed09dab49af658c34624d75491861404.jpg" class="seiperimg" />
          </el-carousel-item>
        </el-carousel>
        <img src="http://p0.meituan.net/codeman/e473bb428f070321269b23370ff02ba956209.jpg" class="seiperimg2" />
        <el-carousel class="seiperBox1" height="170px" :interval="4000" indicator-position="none">
          <el-carousel-item v-for="item in 4" :key="item">
            <img src="http://p1.meituan.net/codeman/826a5ed09dab49af658c34624d75491861404.jpg" class="seiperimg1" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="body2Box3">
        <div class="body2Box3_1">
          <div v-if="isLogin=='true'">
            <div class="userPhotoBox" @click="my()">
              <img src="http://p1.meituan.net/codeman/826a5ed09dab49af658c34624d75491861404.jpg" class="userPhoto"/>
            </div>
            <div class="userName" @click="my()">Hi~ 小汪{{isLogin1}}</div>
            <div class="userBox">
              <div>
                <img src="../../../static/image/dd.png" class="ddimg" @click="my()"/>
                <div class="ddname">订单</div>
              </div>
              <div>
                <img src="../../../static/image/wd.png" class="ddimg" @click="my()"/>
                <div class="ddname">我的</div>
              </div>
              <div>
                <img src="../../../static/image/tc.png" class="ddimg" @click="goOut()"/>
                <div class="ddname">退出登录</div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="userPhotoBox">
              <img src="http://p1.meituan.net/codeman/826a5ed09dab49af658c34624d75491861404.jpg" class="userPhoto"/>
            </div>
            <div class="userName">Hi~ 欢迎来到卡丁生活 {{isLogin1}}</div>
            <div class="buttonBox">
              <el-button round style="width: 120px;" @click="login">登录</el-button>
            </div>
            <div class="buttonBox">
              <el-button round style="width: 120px;" @click="register">注册</el-button>
            </div>
          </div>
        </div>
        <div class="body2Box3_2">
          <img src="../../../static/image/ewm.jpg" class="ewm"></img>
          <div class="body2Box3_2_1">卡丁生活小程序</div>
          <div class="body2Box3_2_2">干啥都打折</div>
        </div>
      </div>
      <div class="typeZZC" v-show="isStopRoll" @mouseenter="StopRoll()" @mouseleave="UpRoll()">
        {{selStopRoll}}
      </div>
    </div>
    <div class="shopBox">
      <div class="shopType">为你推荐</div>
      <div class="shop" v-for="(item,i) in shopList" :key="i" @click="shop()">
        <img src="http://p1.meituan.net/codeman/826a5ed09dab49af658c34624d75491861404.jpg" class="shopImg" />
        <div class="shopName">{{item.name}}</div>
        <div class="shopInformation">
          <div>销量:10000</div>
          <div>粉丝数:5000</div>
          <div>获赞数:5000</div>
          <div>和平区三好街</div>
        </div>
        <div class="shopPrice">人均<span>￥80</span></div>
      </div>
    </div>
    <div style="height: 40px;"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        ssinput:"",//搜索框
        typeList:[{name:"美食"},{name:"外送"},{name:"到店"},{name:"上门"},{name:"KTV"},{name:"宾馆"},{name:"酒吧"}],
        shopList:[
          {shopid:1,url:'',name:"妈妈米线"},{shopid:1,url:'',name:"妈妈米线"},{shopid:1,url:'',name:"妈妈米线"},{shopid:1,url:'',name:"妈妈米线"},
          {shopid:1,url:'',name:"妈妈米线"},{shopid:1,url:'',name:"妈妈米线"},{shopid:1,url:'',name:"妈妈米线"},{shopid:1,url:'',name:"妈妈米线"},
          {shopid:1,url:'',name:"妈妈米线"},{shopid:1,url:'',name:"妈妈米线"}
        ],
        typeList1:[
          {id:1,name:"宾馆"},{id:2,name:"宾馆"},{id:3,name:"宾馆"},{id:4,name:"宾馆"},{id:5,name:"宾馆"},{id:6,name:"宾馆"},{id:7,name:"宾馆"},{id:8,name:"宾馆"},
          {id:9,name:"宾馆"},{id:10,name:"宾馆"},{id:11,name:"宾馆"},{id:12,name:"宾馆"},{id:13,name:"宾馆"}
        ],
        isStopRoll:false,//二级菜单弹窗
        selStopRoll:1,//二级菜单弹窗数据
        isLogin:false,//是否登录
        isLogin1:false,
      }
    },
    //初始化
    created(){
      if(this.$store.state.login){
        this.isLogin1=true
      }
      console.log(localStorage.getItem("isLogin"))
      this.isLogin =localStorage.getItem("isLogin");
      console.log(this.isLogin)

    },
    beforeCreate () {
      document.querySelector('body').setAttribute('style', 'background-color:#F8F8F8')
    },
    beforeDestroy () {
      document.querySelector('body').removeAttribute('style')
    },
    methods:{
      // 搜索
      selButton(){
        console.log("搜索")
      },
      // 选择分类
      selType(e,r){
        // console.log(e)
        // console.log(r)
      },
      //鼠标悬停耳机菜单
      StopRoll(e){
        // console.log("鼠标悬停耳机菜单"+e)
        this.isStopRoll = true
        this.selStopRoll=e

      },
      //鼠标离开二级菜单
      UpRoll(e){
        // console.log("鼠标离开二级菜单")
         this.isStopRoll = false
      },
      //登录
      login() {
        this.$router.push('/login')
      },
      //注册
      register(){
        this.$router.push('/register')
      },
      //跳到我的页面
      my(){
        this.$router.push('/my')
      },
      //跳转到店铺页面
      shop(){
        this.$router.push('/shop')
      },
      //退出
      goOut(){
        localStorage.setItem("isLogin",false);
        this.isLogin =false
        console.log(localStorage.getItem("isLogin"))
      }
    }
  }
</script>
<style scoped>
  input{
    box-shadow:none;
    outline: none;
    resize: none;
    border: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    border-radius: 0;
  }
  .hello{
    width: 100%;
  }
  .body1Box{
    width: 100%;
    background-color: #FFFFFF;
    margin:0rpx auto;
    box-shadow: 0px 5px 10px #ccc;
  }
  .body1Box1{
    width:1200px;
    height: 100px;
    position: relative;
    margin: 0px auto;
  }
  .body1Box1_1{
    width:1200px;
    height: 100px;
  }
  .body1Box1_2{
    position: absolute;
    top: 30px;
    left: 370px;
    width: 640px;
    height: 40px;
    font-size: 18px;
  }
  .body1Box1_3{
    width: 75px;
    height: 48px;
    position: absolute;
    top: 28px;
    left: 1028px;
  }
  .body1Box2{
    width: 1200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    margin: 0px auto;
  }
  .body1Box2>div{
    padding: 10px 15px;
    font-size: 20px;
    font-weight: 600;
    cursor:pointer
  }
  .body1Box2>div:hover{
    color: #FD8723;
  }
  .body2Box{
    width: 1200px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    position: relative;
  }
  .body2Box1{
    width: 205px;
    height: 420px;
    border: 1px solid #cccccc;
    background-color: #FFFFFF;
  }
  .body2Box1_1Box{
    width: 205px;
  }
  .body2Box2{
    width: 740px;
    height: 420px;
    background-color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .body2Box3{
    width: 232px;
    height: 420px;
    background-color: #FFFFFF;
  }
  .body2Box1_1{
    width: 185px;
    padding:0px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    color: #999999;
  }
  .body2Box1_1:hover{
    background-color: #fdf8f3;
    color: #FD8723;
  }
  .typePhoto{
    width: 15px;
    height: 15px;
  }
  .typeBox{
    width: 130px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
  }
  .you{
    width: 12px;
    height: 12px;
  }
  .seiperBox{
    width: 550px;
  }
  .seiperimg{
    width: 550px;
    height: 240px;
  }
  .seiperimg2{
    width: 180px;
    height: 240px;
  }
  .seiperBox1{
    width: 740px;
    margin-top: 10px;
    height: 175px;
    overflow: hidden;
  }
  .seiperimg1{
    width: 740px;
    height: 175px;
  }
  .body2Box3_1{
    border: 1px solid #cccccc;
    width: 230px;
    height: 238px;
  }
  .userPhotoBox{
    width: 48px;
    height: 48px;
    border-radius: 50px;
    border: 4px solid #cccccc;
    margin: 30px auto 0px;
  }
  .userPhoto{
    width: 48px;
    height: 48px;
    border-radius: 50px;
  }
  .userBox{
    width: 200rpx;
    display: flex;
    flex-wrap: wrap;
    margin: 0px 15px;
  }
  .userBox>div{
    width: 60px;
    height: 55px;
    margin-left: 5px;
  }
  .ddimg{
    width: 25px;
    height: 25px;
    margin: 0px auto;
    display: block;
  }
  .ddname{
    width: 60px;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    text-align: center;
  }
  .userName{
    width: 230px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
  }
  .buttonBox{
    width: 230px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
  .body2Box3_2{
    border: 1px solid #cccccc;
    width: 230px;
    height: 168px;
    margin-top: 10px;
  }
  .ewm{
    width: 80px;
    height: 80px;
    margin: 20px auto 0px;
    display: block;
  }
  .body2Box3_2_1{
    width: 230px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    margin-top: 15px;
  }
  .body2Box3_2_2{
    width: 230px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
  }

  .typeZZC{
    width: 987px;
    height: 414px;
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: #FFFFFF;
    z-index: 99;
    border: #FD8723 3px solid;
  }
  .shopBox{
    width: 1198px;
    border: 1px solid #CCCCCC;
    background-color: #fff;
    margin: 0px auto;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;
  }
  .shopType{
    width: 1170px;
    height: 60px;
    font-size: 24px;
    line-height: 60px;
    font-weight: 600;
    margin-left: 16px;
  }
  .shop{
    width: 220px;
    height: 315px;
    margin-left: 16px;
    margin-bottom: 16px;
  }
  .shopImg{
    width: 220px;
    height: 220px;
    border-radius: 10px;
  }
  .shopName{
    width: 220px;
    height: 25px;
    line-height: 25px;
    font-size: 16px;
    font-weight: 600;
  }
  .shopInformation{
    display: flex;
    flex-wrap: wrap;
  }
  .shopInformation>div{
    width:110px;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    color: #666;
  }
  .shopPrice{
    width: 220px;
    height: 30px;
    line-height: 30px;
    font-size: 20px;
    font-weight: 600;
    color: #FD8723 ;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoppingMall/index.vue